import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class RouteLink extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Link
        className={this.props.className}
        onMouseDown={this.props.onMouseDown}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        to={this.props.href}
      >
        {this.props.children}
      </Link>
    );
  }
}

RouteLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

RouteLink.defaultProps = {
  onMouseDown: () => true,
  onMouseEnter: () => true,
  onMouseLeave: () => true,
};

export default RouteLink;
